import { MutationTree, GetterTree } from 'vuex'
import { SET_TICKET, SET_SKU, } from '../types'
import { RootState } from '..'
import { Product } from '@/utils/shopify'


export interface TicketState {
    ticket: Product | null;
    sku: string | null;
}

const ticketState: TicketState = {
    ticket: null,
    sku: null
}

const getters: GetterTree<TicketState, RootState> = {
    getTicket: (state) => state.ticket,
    getSku: (state) => state.sku
}

const mutations: MutationTree<TicketState> = {
    [SET_TICKET](state, ticket: Product) {
        state.ticket = ticket
    },
    [SET_SKU](state, ticket: Product) {
        state.sku = ticket.variants.edges[ticket.variants.edges.length - 1].node.sku ?? null
    }
}

export default {
    state: ticketState,
    getters,
    mutations,
}
